export default __webpack_public_path__ + "static/media/github1.789eb418.png";